import React, { Component } from 'react'
import Fuse from 'fuse.js'
import {
  hhs_business_units,
  office_of_the_secretary,
  hhs_programs
} from 'hotline_complaint_choices'
import { SearchForm } from '../SearchForm'
import { ProgramSearchResults } from './ProgramSearchResults'

export class ProgramSearch extends Component {
  state = {
    search: '',
    results: [],
    showSearch: false
  }

  /*
   * Define the fuse.js search options
   * See fusejs.io for details
   */
  options = {
    keys: ['program', 'office', 'bizunit'],
    findAllMatches: true,
    shouldSort: true,
    minMatchCharLength: 3,
    threshold: 0.3
  }

  /*
   * Create an array of objects with program, office, bizunit attributes
   * to be searched
   */
  businessUnits = Object.keys(hhs_business_units).reduce(
    (acc, key) => [
      ...acc,
      ...Object.keys(hhs_business_units[key]).map(bizunitKey => {
        let program = ''
        let programKey = ''
        let office = ''
        let officeKey = ''
        if (office_of_the_secretary.hasOwnProperty(key)) {
          program = hhs_programs['OS']
          programKey = 'OS'
          office = office_of_the_secretary[key]
          officeKey = key
        } else {
          program = hhs_programs[key]
          programKey = key
        }
        return {
          program: program,
          programKey: programKey,
          office: office,
          officeKey: officeKey,
          bizunit: hhs_business_units[key][bizunitKey],
          bizunitKey: bizunitKey
        }
      })
    ],
    []
  )

  // Create the search engine
  fuser = new Fuse(this.businessUnits, this.options)

  // Hide the search display
  hideSearch = () => {
    this.setState({ showSearch: false })
  }

  // Use the search engine to find the searchTerm
  _searchOnSubmit = searchTerm => {
    let found = searchTerm !== '' ? this.fuser.search(searchTerm) : []

    //Update the display with the items found
    this.setState({
      results: found,
      search: searchTerm
    })
  }

  render() {
    return this.state.showSearch ? (
      <div className={`ds-u-padding--2 ds-u-border--1`}>
        <div className="ds-l-form-row">
          <div className="ds-l-col--11">
            <h2 className="ds-u-margin-top--1 ds-u-margin-bottom--1">
              Search programs
            </h2>
          </div>
          <div className="ds-l-col--1 ds-u-align-items--center">
            <a href="javascript:void(0)" onClick={this.hideSearch}>
              Close
            </a>
          </div>
        </div>
        <div className="ds-l-form-row">
          <div className="ds-l-col">
            <p>
              Search for programs, Office of Secretary, or business unit. Select
              the appropriate choice from the search results to add to the form.
            </p>
          </div>
        </div>
        <SearchForm
          label=""
          term={this.state.search}
          onSubmit={this._searchOnSubmit}
        />
        <ProgramSearchResults
          search={this.state.search}
          results={this.state.results}
          setFieldValue={this.props.setFieldValue}
          hideSearch={this.hideSearch}
        />
      </div>
    ) : (
      <div className="ds-l-form-row">
        <div className="ds-l-col--auto">
          Need help finding the program and/or business unit?
        </div>
        <div className="ds-l-col--auto">
          <a
            href="javascript:void(0)"
            onClick={() => {
              this.setState({ showSearch: true })
            }}
          >
            Search programs
          </a>
        </div>
      </div>
    )
  }
}
